import { render, staticRenderFns } from "./cmpdetalhespedido.vue?vue&type=template&id=62ebfd7a&"
import script from "./cmpdetalhespedido.vue?vue&type=script&lang=js&"
export * from "./cmpdetalhespedido.vue?vue&type=script&lang=js&"
import style0 from "./cmpdetalhespedido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports